import toSlug from 'slugify';

export const capitalizeWord = (word: string) => word.charAt(0).toUpperCase() + word.slice(1);

export const slugify = (value: string) => toSlug(value, { lower: true, trim: true, replacement: '-', strict: true });
export const deslugify = (value: string) => capitalizeWord(value.replace(/-+/g, ' '));
export const convertToNormalDate = (date: string | number | Date) => new Date(date).toISOString().slice(0, 10);
